import React from 'react';

// Local logo file in public folder
const LOGO_URL = "/logo.png";

export const Logo = ({ className = "h-10", white = false, showText = true }) => (
  <img 
    src={LOGO_URL}
    alt="NewSlate"
    className={`${className} object-contain`}
    style={white ? { filter: 'brightness(0) invert(1)' } : {}}
  />
);

export const LogoIcon = ({ className = "w-10 h-10" }) => (
  <img 
    src={LOGO_URL}
    alt="NewSlate"
    className={`${className} object-contain`}
  />
);

export default Logo;
